import { ProcedureCoreComponent } from './../../back-office/procedure-management/procedure-core/procedure-core.component';
import { AfterViewInit, Component, Input, OnInit } from "@angular/core";

export class PraticaIndexItem {
  id?: number;
  label: string;
  url?: string;
  cssId?: string;
  childs?: PraticaIndexItem[];
}

@Component({
  selector: "app-pratica-index",
  templateUrl: "./pratica-index.component.html",
  styleUrls: ["./pratica-index.component.scss"],
})
export class PraticaIndexComponent implements OnInit {

  @Input() public coreComponent: ProcedureCoreComponent;

  @Input() linkList: PraticaIndexItem[];

  public selectedIndex = null;

  ngOnInit() {
    window.addEventListener("scroll", () => {
      const scrollableY = window.scrollY;
      this.linkList[0].childs.forEach((r, i) => {
        const el = document.getElementById(r.cssId);
        const delta = 192;
        if (el &&
          el.offsetTop - scrollableY <= delta &&
          el.offsetTop - scrollableY >= -delta
        ) {
          this.selectedIndex = i;
        }
      });
    });
  }

  scrollToElement(element: PraticaIndexItem, k) {
    const el = document.getElementById(element.cssId);
   /*  el.scrollTop = 90; */
    this.selectedIndex = k;
    el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
  }
  doEmit() {}

  get showContropartiLink() {
    if (this.coreComponent && this.coreComponent.procedureManagmentForm &&
        this.coreComponent.procedureManagmentForm.get('controparti') &&
        this.coreComponent.procedureManagmentForm.get('controparti').value)
      return this.coreComponent.procedureManagmentForm.get('controparti').value.length > 0;
    else
      return false;
  }

  get showIntestatariLink() {
    if (this.coreComponent && this.coreComponent.procedureManagmentForm &&
        this.coreComponent.procedureManagmentForm.get('intestatari') &&
        this.coreComponent.procedureManagmentForm.get('intestatari').value)
      return this.coreComponent.procedureManagmentForm.get('intestatari').value.length > 0;
    else
      return false;
  }

  get showRichiedentiLink() {
    if (this.coreComponent && this.coreComponent.procedureManagmentForm &&
        this.coreComponent.procedureManagmentForm.get('richiedenti') &&
        this.coreComponent.procedureManagmentForm.get('richiedenti').value)
      return this.coreComponent.procedureManagmentForm.get('richiedenti').value.length > 0;
    else
      return false;
  }

}
